import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import UserService from "services/UserService";

export const getUsers = createAsyncThunk(
  "user/getUsers",
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserService.getUsers(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const downloadUserExcel = createAsyncThunk(
  "user/downloadUserExcel",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await UserService.downalodUserExcel(data, params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getSingleUser = createAsyncThunk(
  "user/getSingleUser",
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserService.getSingleUser(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const addUser = createAsyncThunk(
  "user/addUser",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await UserService.addUser(data, params);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add user"
      );
    }
  }
);

export const editUser = createAsyncThunk(
  "user/editUser",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await UserService.editUser(params, data);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editUserStatus = createAsyncThunk(
  "user/editUserStatus",
  async ({ data, status }, { rejectWithValue }) => {
    try {
      const response = await UserService.editUserStatus(data, status);
      return response;
    } catch (err) {
      console.log(err)
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);

const userSlice = createSlice({
  name: "users",
  initialState: {
    users: {},
    singleUser: {},
    excelLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(downloadUserExcel.pending, (state) => {
        state.excelLoading = true;
        state.error = null;
      })
      .addCase(downloadUserExcel.fulfilled, (state, action) => {
        state.excelLoading = false;
        // state.userEscel = action.payload;
      })
      .addCase(downloadUserExcel.rejected, (state, action) => {
        state.excelLoading = false;
        state.error = action.payload;
      })
      .addCase(getSingleUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleUser.fulfilled, (state, action) => {
        state.loading = false;
        state.singleUser = action.payload;
      })
      .addCase(getSingleUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editUserStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editUserStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editUserStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { } = userSlice.actions;
export default userSlice.reducer;
